<template>
<div>
	<div class="container">
		<div class="cover">
			<img :src="img_src" alt="">
		</div>
        <div class="passDiv">
         <input v-model="password" type="password" placeholder="请输入观看码" class="passText"/>
         <button type="primary" @click="meetingPassword" class="button" >确定</button>   
        </div>
	</div>
</div>
</template>
<script>
	import {MeetingPassword} from "../../config/interface.js"
	export default{
	    props:{
	    	
	  	},
		data(){
			return{
                meeting_id:0,
                img_src:'',
				password:''
			}
		},
		mounted(){
			
            this.meeting_id=this.$route.query.meeting_id;
            this.img_src=this.$route.query.img_src;
			
		},
		methods:{
			//输入密码 正确跳转 错误提示错误信息
			meetingPassword(){
				const url=MeetingPassword;
				const method='POST';
				let params={
					meeting_id:this.meeting_id,
					watch_password:this.password
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.$router.push({
						path:'/meeting/details',
						query:{
							meeting_id:this.itemContent.id
						}
					})
					}
					else{
							this.$toast.fail({
          						message:res.error_msg,
          						position:'top'
        					});
					}
				})
			}
		}
	}
</script>
<style lang="scss">
	.cover{
		img{
			width:100%;
		}
	}
    .passDiv{
        margin-top:50px;
        display: flex;
        justify-content: center;
        .passText{
            height: 45px;
            font-size: 17px;
            width:180px;
            text-align: center;
        }
        .button{
            margin-left:20px ;
            height: 48px;
            width:90px;
            font-size: 17px;
            color: white;
            background-color:#308dba; 
            border:none;
        }
    }

</style>


// WEBPACK FOOTER //
// src/pages/Meeting/password.vue